module.exports = __webpack_public_path__ + "static/img/password.8d3ac37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/password.png
// module id = dVhp
// module chunks = 1